<template>
  <el-tabs v-model="activeName">
    <el-tab-pane label="线上样品" name="list">
      <List ref="list" />
    </el-tab-pane>
    <el-tab-pane label="上传记录" name="history">
      <History ref="history" />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import History from './History.vue';
import List from './List.vue';

export default {
  name: 'product-list',
  components: {
    List,
    History
  },
  data() {
    return {
      activeName: 'history',
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 跳转到列表页
      if (to.params.status === 'create' || to.params.status === 'update') {
        vm.activeName = 'history';
        vm.reloadData();
      }
    });
  },
  watch: {
    activeName(val) {
      if (val === 'list' || val === 'history') {
        this.$refs[val].getList();
      }
    },
  },
  methods: {
    reloadData() {
      this.$nextTick(() => {
        this.$refs[this.activeName].onSearch();
      });
    },
  },
};
</script>
